/* 純數學工具。無任何相依，可在 Node 裡直接載入。 */

export var TAU = Math.PI * 2;
export function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
export function lerp(a, b, t) { return a + (b - a) * t; }
/* rnd() 只准用在「刪掉也不會改變對局結果」的地方：殘骸飛散、傷害數字漂移、
   推進器火焰、鏡頭震動、敵人機體的預告抖動。
   任何會影響命中、掉落落點、目標選擇、生成位置的亂數一律用 rr() / rri() / rpick()。
   判準：如果這個亂數的結果會被別的邏輯讀到，它就是對局亂數。
   2026-08-01 修正：原本主砲散佈、飛彈目標與初速、經驗球初速都誤用了 rnd()，
   導致同一顆種子跑兩次結果不同，seed 形同虛設。 */
export function rnd(a, b) { return a + Math.random() * (b - a); }
export function damp(a, b, l, dt) { return lerp(a, b, 1 - Math.exp(-l * dt)); }
